import { render } from "./all_student.vue?vue&type=template&id=9caac610&scoped=true"
import script from "./all_student.vue?vue&type=script&lang=js"
export * from "./all_student.vue?vue&type=script&lang=js"

import "./all_student.vue?vue&type=style&index=0&id=9caac610&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9caac610"]])

export default __exports__